const prod = {
  SITE_URL: 'https://app.jobswidget.me',
  API_URL: 'https://app.jobswidget.me/api/v1/',
  WEBSOCKET_URL: 'wss://app.jobswidget.me/ws',
};

export { prod as default };
